import { useCallback } from "react";
import { find } from "lodash";
import { Locale } from "@linkfluence/models/locale";
import { useCurrentUserLocale } from "@radarly/core/user/use-cases";
import { tr } from "@radarly/i18n";
import {
  DatavizMultipleLineChart,
  updateDatavizOptions,
} from "@radarly/models/dataviz";

function getSortOptions(locale: Locale) {
  return [
    {
      value: "alpha",
      label: tr(locale, "CUSTOM_PAGES::EDITOR::DATAVIZ::SORT_BY_NAME"),
    },
    {
      value: "volumeDesc",
      label: tr(locale, "CUSTOM_PAGES::EDITOR::DATAVIZ::SORT_BY_VOLUME_DESC"),
    },
  ];
}

function getSortOption(dataviz: DatavizMultipleLineChart, locale: Locale) {
  const sortOptions = getSortOptions(locale);
  const value = dataviz.legendSort || "volumeDesc";
  return {
    value,
    label: find(sortOptions, { value })?.label,
  };
}

export function useSort(
  dataviz: DatavizMultipleLineChart,
  setDataviz: (dataviz: DatavizMultipleLineChart) => void
) {
  const locale = useCurrentUserLocale();
  const options = getSortOptions(locale);
  const onChange = useCallback(
    ({ value }) => {
      setDataviz(updateDatavizOptions(dataviz, "legendSort", value));
    },
    [dataviz, setDataviz]
  );
  const option = getSortOption(dataviz, locale);
  return {
    label: tr(locale, "CUSTOM_PAGES::EDITOR::DATAVIZ::LEGEND_SORT"),
    options,
    onChange,
    option,
  };
}
